import './notification-toast-item.styles.scss';

export default angular.module('directives.abNotificationToastItem', [])
  .directive('abNotificationToastItem', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        toast: '=',
        markRead: '&',
        clickNotification: '&',
      },
      templateUrl: require('./notification-toast-item.template.html'),
    };
  })
  .name;
